import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'failed-multiple-actions-dialog',
  templateUrl: './failed-multiple-actions-dialog.component.html',
  styleUrls: ['./failed-multiple-actions-dialog.component.scss']
})
export class FailedMultipleActionsDialogComponent implements OnInit {

  onlyErrors: any;
  constructor(public dialogRef: MatDialogRef<FailedMultipleActionsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
    this.onlyErrors = this.getError();
  }

  ok(): void {
    this.dialogRef.close();
  }

  getError(): any {
   return this.data.message.filter((item) => {
      return item.status !== 200;
    });

  }
}
